__turbopack_context__.v({
  "dotted-outline": "styles-module__cnVZwq__dotted-outline",
  "drag-wrapper-span": "styles-module__cnVZwq__drag-wrapper-span",
});
